import { useAuth } from 'grabbitbot-legacy-ui'

/**
 * Equivalent of legacy `UserComponent` (route `/user`) — a trivial "current
 * user email" display (audit §3a: "dead 30s keep-alive polling loop whose
 * actual API call is commented out — a no-op"; the polling itself is not
 * ported, it never did anything). No `/user/*` update endpoint exists in the
 * contract (`GET|POST /user/current`, `/whoami` are read-only echoes), so
 * this stays read-only, same as the screener's port of the same component.
 */
export function UserPage() {
  const { user } = useAuth()
  if (!user) return null

  return (
    <div className="portal-card portal-card--profile">
      <h1>Account</h1>
      <dl>
        <dt>Email</dt>
        <dd>{user.username}</dd>
        {user.roles && user.roles.length > 0 && (
          <>
            <dt>Roles</dt>
            <dd>{user.roles.join(', ')}</dd>
          </>
        )}
      </dl>
    </div>
  )
}
